module.exports = __webpack_public_path__ + "img/congrats.0aec3ade.jpeg";